
import { CommentThread } from "./CommentThread";
import { CommentForm } from "./CommentForm";

interface Comment {
  id?: string;
  username: string;
  userId: string;
  content: string;
  createdAt?: string;
  parentId?: string;
  replies?: Comment[];
  reactions?: {
    likes: number;
    hearts: number;
    supports: number;
  };
  postId: string;
}

interface CommentsProps {
  comments: Comment[];
  onAddComment: (content: string, parentId?: string) => void;
  onAddReaction: (commentId: string, reactionType: 'likes' | 'hearts' | 'supports') => void;
  postId?: string;
  postContent?: string;
  postCategory?: string;
}

export const Comments = ({ comments, onAddComment, onAddReaction, postId, postContent, postCategory }: CommentsProps) => {
  // Deduplicate comments by their id
  const uniqueCommentsMap = new Map();
  comments.forEach(comment => {
    if (comment.id && !uniqueCommentsMap.has(comment.id)) {
      uniqueCommentsMap.set(comment.id, comment);
    }
  });
  
  // Convert Map back to array
  const uniqueComments = Array.from(uniqueCommentsMap.values());

  return (
    <div className="w-full space-y-4">
      <CommentForm
        onSubmit={(content) => onAddComment(content)}
        placeholder="Share some positivity..."
        buttonText="Share"
        postId={postId}
        postContent={postContent}
        postCategory={postCategory}
      />
      {uniqueComments.map((comment) => (
        <CommentThread
          key={comment.id}
          comment={{ ...comment, postId: postId || '' }}
          onAddComment={onAddComment}
          onAddReaction={onAddReaction}
        />
      ))}
    </div>
  );
};
